import DceHTMLElement from "./html/DceHTMLElement";
import DceHTMLElementExtension from "./html/DceHTMLElementExtension";

/**
 * Kontruktor komponentu
 */
export type DceComponentConstructor<T> = {
    new (elem: DceHTMLElement, props: any): T;
    readonly prototype: T;
};

/**
 * Bazowa klasa komponentu
 */
export default class DceComponent<T> {

    protected _props: T;

    protected elem: DceHTMLElement;

    constructor(elem: DceHTMLElement, props: T | null) {
        this.elem = elem;
        this._props = {...(this.defaultProps()), ...props};
    }

    get ext(): DceHTMLElementExtension {
        return this.elem.ext;
    }

    get props(): T {
        return this._props;
    }

    public defaultProps(): Partial<T> {
        return {};
    }

    public onInit() {

    }

    public onRemove() {

    }

}
